import { types } from '@actions/conferences';
import { mapPaginationValues } from '@services/dashboardResource';
import { DASHBOARD } from '@config/modelsConfig';

export const initialState = {
  list: [],
  numberPerPage: DASHBOARD.NUMBER_PER_PAGE,
  currentPage: 1,
  total: null,
  totalPages: 1,
  isFetching: false,
  [DASHBOARD.FILTER.FROM_DATE]: null,
  [DASHBOARD.FILTER.TO_DATE]: null,
  [DASHBOARD.FILTER.TITLE]: '',
  [DASHBOARD.FILTER.ANALYST]: '',
  order: 'creationDate DESC',
  isRegenerating: false,
  isCloudSearchResults: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.CLEAN_DASHBOARD:
      return {
        ...initialState,
      };
    case types.GET_CONFERENCES_LIST.STARTED:
      return {
        ...state,
        isFetching: true,
      };
    case types.GET_CONFERENCES_LIST.SUCCESS:
      return {
        ...state,
        list: action.list,
        ...mapPaginationValues(action.meta),
        isFetching: false,
      };
    case types.GET_CONFERENCES_LIST.FAILURE:
      return {
        ...state,
        isFetching: false,
      };
    case types.SET_CONFERENCES_FILTER:
      return {
        ...state,
        [action.field]: action.value,
      };
    case types.SET_CONFERENCES_ORDER:
      return {
        ...state,
        [action.field]: action.value,
      };
    case types.REGENERATE_PIN_FROM_DASHBOARD.STARTED:
    case types.CANCEL_CONFERENCE_CALL.STARTED:
      return {
        ...state,
        isRegenerating: action.conferenceId,
      };
    case types.REGENERATE_PIN_FROM_DASHBOARD.SUCCESS:
    case types.CANCEL_CONFERENCE_CALL.SUCCESS:
      return {
        ...state,
        list: state.list.map((conference) =>
          String(conference.id) === String(action.conferenceId)
            ? { ...conference, pin: action.pin }
            : conference,
        ),
        isRegenerating: false,
      };
    case types.REGENERATE_PIN_FROM_DASHBOARD.FAILURE:
    case types.CANCEL_CONFERENCE_CALL.FAILURE:
      return {
        ...state,
        isRegenerating: false,
      };
    case types.CALL_ATTENDEE.SUCCESS:
      return {
        ...state,
        list: state.list.map((conference) =>
          String(conference.id) === String(action.data.conferenceId)
            ? {
                ...conference,
                people: conference.people.map((person) =>
                  person.id === action.data.attendeeId
                    ? {
                        ...person,
                        called: true,
                      }
                    : person,
                ),
              }
            : conference,
        ),
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./redux/reducers/conferences.js